import { IOpenInvitation } from 'src/types/OpenInvitation';

import { IUserInvitation } from '../types/UserInvitation';
import { INVITATION_STATE } from '../types/UserInvitationState';

import { API_URL_PATHS } from './server/ApiUrlPaths';
import { apiCall } from './server/ServerApi';

const { TENANTS_URL_PATH, USER_INVITATIONS_URL_PATH, OPEN_INVITATIONS_URL_PATH } = API_URL_PATHS;

const states = 'PENDING,EXPIRED';
const cachedInvitations: IOpenInvitation[] = [];

export async function getInvitation(
	tenantId: string,
	invitationId: string
): Promise<IUserInvitation> {
	return apiCall('GET', `${TENANTS_URL_PATH}/${tenantId}/user-invitations/${invitationId}`);
}

export async function createInvitation(
	email: string,
	firstname: string,
	lastname: string,
	tenantId: string,
	roleType: string
): Promise<IUserInvitation> {
	const body = {
		targetName: firstname,
		targetSurname: lastname,
		targetEmail: email,
		roleType
	};
	return apiCall('POST', `${TENANTS_URL_PATH}/${tenantId}${USER_INVITATIONS_URL_PATH}`, {
		data: body
	});
}

export async function revokeInvitation(
	inviteId: string,
	tenantId: string
): Promise<IUserInvitation> {
	return apiCall(
		'DELETE',
		`${TENANTS_URL_PATH}/${tenantId}${USER_INVITATIONS_URL_PATH}/${inviteId}`
	);
}

export async function getAllInvitations(tenantId: string): Promise<Array<IUserInvitation>> {
	return apiCall('GET', `${TENANTS_URL_PATH}/${tenantId}/user-invitations?states=${states}`);
}

export enum PUBLIC_INVITATON_STATE {
	SIGNED_UP = 'SIGNED_UP',
	NOT_SIGNED_UP = 'NOT_SIGNED_UP'
}
type PublicStateResponse = {
	state: PUBLIC_INVITATON_STATE;
};
export async function getInvitationTokenPublicState(
	invitationToken: string
): Promise<PublicStateResponse> {
	return apiCall('GET', `${USER_INVITATIONS_URL_PATH}/public-state?token=${invitationToken}`);
}
export async function getAllUserPendingInvitations(): Promise<IUserInvitation[]> {
	const invitations = await apiCall('GET', USER_INVITATIONS_URL_PATH);
	return invitations.filter((i: IUserInvitation) => i.state === INVITATION_STATE.PENDING);
}

export async function acceptInvitation(invitationToken: string): Promise<IUserInvitation> {
	return apiCall('POST', `${USER_INVITATIONS_URL_PATH}/accept?token=${invitationToken}`);
}

export async function acceptOpenInvitation(invitationToken: string): Promise<IUserInvitation> {
	return apiCall('POST', `${OPEN_INVITATIONS_URL_PATH}/connect?token=${invitationToken}`);
}

export async function getOpenInvitationDetails(invitationToken: string): Promise<IOpenInvitation> {
	return apiCall('GET', `${OPEN_INVITATIONS_URL_PATH}/state?token=${invitationToken}`);
}

export async function getOpenInvitationsDetails(): Promise<IOpenInvitation[]> {
	if (cachedInvitations.length) {
		return cachedInvitations;
	}
	const result = await apiCall('GET', OPEN_INVITATIONS_URL_PATH);
	if (cachedInvitations.length === 0) {
		cachedInvitations.push(...result);
	}
	return result;
}
